export default __webpack_public_path__ + "static/media/planning.06ea8c3a.png";